// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"BY-z","upvoteIcon":"CY-z","downvoteIcon":"DY-z","feedbackIcon":"EY-z"};